import { ReactNode } from 'react';

interface PermissionProps {
  roles: string[];
  children: ReactNode;
}

const Permission = ({ roles, children }: PermissionProps) => {
  const role = localStorage.getItem("role");
  console.log(role);
  console.log(role ? roles.includes(role) : false, "roles status");

  const normalizedRole = role ? role.toLowerCase() : "";
  if (!normalizedRole || !roles.map(r => r.toLowerCase()).includes(normalizedRole)) return null;
  return <>{children}</>;
};

export default Permission;
